import styled from 'styled-components';

export const RelatedCategoriesWrapper = styled.div.withConfig({
  displayName: 'RelatedCategoriesWrapper',
  componentId: 'related-categories-wrapper',
})([
  `
    margin-bottom: 32px;

    h2, > h2 {
        width: 100%;
        font-style: normal;
        font-weight: 530;
        line-height: 120%;
        text-align: center !important;
        padding-bottom: 16px;
        font-size: 36px;
    }

    h3 {
        width: 100%;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        text-align: center;
        padding-bottom: 16px;
        font-size: 27px;
    }

    /* The non-startpage headline renders as h2 for the heading hierarchy but
       must keep the h3 spacing above; the global theme's "h2 { padding: 0 }"
       outranks the rules in this block, so re-assert with a class selector. */
    h2:not(.STARTPAGE) {
        padding-bottom: 16px;
    }

    > div {
        justify-content: center;
    }

    .category {
        height: 150px;
        background: rgb(4, 68, 155);
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(180deg, #05489E 0%, #05489E 0.01%, #003480 51.04%, #002760 100%);

        h4, h3 {
            color: #FFF;
            font-style: normal;
            font-weight: 530;
            line-height: 120%;
            transition: font-size .1s;
            text-align: center;
            padding: 0 10px;
            min-width: 300px;
            font-size: 24px;

            /* The fixed 24px above outranks the global mobile h4 size that
               applied before the h4->h3 swap; restore the old mobile size. */
            @media screen and (max-width: 481px) {
                font-size: 22px;
            }
        }
    }

    .category:hover > h4,
    .category:hover > h3 {
        font-size: 30px;
    }

    @media screen and (max-width: 481px) {
        .category:hover > h4,
        .category:hover > h3 {
            font-size: 27px;
        }
    }

    .row {
        justify-content: center;
    }
`,
]);
